window.addEventListener("load", function () {
    const sections = document.querySelectorAll('.animation-section-enabled'); // Select the relevant sections

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                const animationText = entry.target.querySelector('.animation-text');
                const animationImage = entry.target.querySelector('.animation-image-enabled');
                const animationImageUpwards = entry.target.querySelector('.animation-image-enabled-upwards');

                if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
                    // Slide in animations
                    if (animationImage) {
                        animationImage.classList.add('in-view');
                    }
                    if (animationImageUpwards) {
                        animationImageUpwards.classList.add('in-view'); // Trigger slide-up animation
                    }
                    if (animationText) {
                        animationText.classList.add('in-view');
                    }
                } else {
                    // Reset animations when sliding out
                    if (animationImage) {
                        animationImage.classList.remove('in-view');
                    }
                    if (animationImageUpwards) {
                        animationImageUpwards.classList.remove('in-view'); // Remove slide-up animation
                    }
                    if (animationText) {
                        animationText.classList.remove('in-view');
                    }
                }
            });
        },
        { threshold: [0.1, 0.5, 0.9] } // Lower thresholds for partial visibility handling
    );

    // Observe sections for animations
    sections.forEach(section => {
        observer.observe(section);
    });
});
